/**
 * 14px in-button spinner. CSS-only so it works regardless of motion lib.
 * Honors prefers-reduced-motion via the global stylesheet rule.
 */
interface SpinnerProps {
  /** Override the stroke color. Defaults to currentColor so it inherits
   *  the surrounding button text color. */
  className?: string;
}

export function Spinner({ className = "" }: SpinnerProps) {
  return (
    <svg
      role="img"
      aria-label="Loading"
      viewBox="0 0 24 24"
      width={16}
      height={16}
      className={["animate-spin", className].join(" ")}
      style={{ animationDuration: "0.8s" }}
    >
      <circle
        cx="12"
        cy="12"
        r="9"
        fill="none"
        stroke="currentColor"
        strokeOpacity="0.25"
        strokeWidth="2.5"
      />
      <path
        d="M21 12a9 9 0 0 0-9-9"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </svg>
  );
}

export default Spinner;
